import { render, staticRenderFns } from "./AddUserDialog.vue?vue&type=template&id=52695561&scoped=true&"
import script from "@/views/Groups/AddUserDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/AddUserDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/add-user-dialog.scss?vue&type=style&index=0&id=52695561&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52695561",
  null
  
)

export default component.exports